export default {
  MY_DRAFTS ({ drafts }) {
    return drafts
  },
  LAST_UPDATED_DRAFT ({ lastUpdatedDraft }) {
    return lastUpdatedDraft
  }
}
